import React from "react";
import TickSvgIcon from "../../assets/icons/TickIcon";

/** Shared selection tick — same glyph as Boards / MultiSelect on the ICH platform. */
const ImageGeneratorSelectionTick: React.FC<{
  className?: string;
  iconClassName?: string;
}> = ({ className = "", iconClassName = "h-2.5 w-3" }) => (
  <span
    className={`absolute left-2 top-2 flex h-5 w-5 items-center justify-center rounded-[4px] border border-[#737373] bg-white shadow-sm ${className}`}
    aria-hidden="true"
  >
    <TickSvgIcon fill="#4d4d4d" className={iconClassName} />
  </span>
);

export default ImageGeneratorSelectionTick;
